/** Kakao JavaScript SDK — loaded from CDN (see loadKakaoSdk). */
export const KAKAO_SDK_URL =
  "https://t1.kakaocdn.net/kakao_js_sdk/2.7.4/kakao.min.js";

export const KAKAO_JAVASCRIPT_KEY =
  process.env.REACT_APP_JAVASCRIPT_API_KEY_KAKAODEV?.trim() ?? "";

/** REST key must never initialize the browser SDK (causes 4019 / domain errors). */
export const KAKAO_REST_API_KEY =
  process.env.REACT_APP_REST_API_KEY_KAKAODEV?.trim() ?? "";

/** Set true to send Feed messages instead of the custom template (isolates template vs domain issues). */
export const KAKAO_SHARE_FORCE_FEED =
  process.env.REACT_APP_KAKAO_SHARE_FORCE_FEED === "true";

/** Custom template ID from Kakao Developers → Kakao Talk Message → Templates. */
export const KAKAO_FAN_CARD_TEMPLATE_ID = Number(
  process.env.REACT_APP_KAKAO_FAN_CARD_TEMPLATE_ID ?? "",
);

/** Season cards reuse the fan-card Kakao custom template (same layout + variables). */
export const KAKAO_SHARED_CARD_TEMPLATE_ID = KAKAO_FAN_CARD_TEMPLATE_ID;

/** Public fallback when card cover is missing (must exist on PUBLIC_SITE_URL). */
export const KAKAO_DEFAULT_OG_IMAGE = "/Brand.png";

/** Kakao field length limits (safe margins). */
export const KAKAO_MAX_TITLE = 200;
export const KAKAO_MAX_DESCRIPTION = 200;
